import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  Avatar,
  Drawer,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import {
  useGetMeetingWithoutDateQuery,
  useGetUserQuery,
  useGetAllHolydaysArrayQuery,
  useGetMeetingQuery,
  useCreateMeetingMutation,
  useGetCustomerQuery,
  useGetTeamQuery,
  useGetAllMeetingSubjectQuery,
  useGetAllPolicyGroupByQuery,
  useGetMeetingCategoryQuery,
  useGetAllHolydaysTitleQuery,
} from "../../../Api/attoDeskApi";
import {
  IMeeting,
  IUserInfo,
  IPolicy,
  ICustomer,
  ITeam,
  IMeetingCategory2,
} from "../../../Api/Interface/api.interface";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import dayGridPlugin from "@fullcalendar/daygrid";
import FullCalendar from "@fullcalendar/react";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import SettingsIcon from "@mui/icons-material/Settings";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import { FaEdit } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { useFormik } from "formik";
import { useNotifier } from "../../../Core/Notifier";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import TimeDropdown from "../../../Components/CustomTimePicker/TimeDropdown";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

interface CustomerOption {
  label: string;
  value: number;
}

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const { data: userData } = useGetUserQuery();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedMeetingData, setSelectedMeetingData] =
    useState<IMeeting | null>(null);
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");
  const prevClientIdRef = useRef<string | "">("");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [newDepartment, { isLoading: meetingSaveIsLoading }] =
    useCreateMeetingMutation();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetMeetingWithoutDateQuery({
    searchText: "",
    staffId: userId || "",
    clientId: "",
    id: "",
    meeting_Date: "",
  });

  const { data: holydaysData, isLoading: holidaysIsLoading } =
    useGetAllHolydaysArrayQuery({
      searchText: "",
      id: "",
    });

  const { data: holydaysTitleData, isLoading: holidaysTitleIsLoading } =
    useGetAllHolydaysTitleQuery({
      searchText: "",
      id: "",
    });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetMeetingQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: selectedId || "",
      meeting_Date: "",
    },
    {
      skip: !selectedId,
    }
  );
  const { data: clientData, isLoading: cilentIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: staffData, isLoading: staffIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: meetingAllData, isLoading: meetingAllIsLoading } =
    useGetAllMeetingSubjectQuery({
      searchText: "",
      id: "",
    });

  const {
    data: policyData,
    isLoading: policyIsLoading,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: selectedCustomerId,
  });

  const {
    data: getAllMeetingCategoryData,
    isLoading: meetingCategoryIsLoading,
  } = useGetMeetingCategoryQuery({
    searchText: "",
  });

  const { data: policyAllData, isLoading: policyAllIsLoading } =
    useGetAllPolicyGroupByQuery({
      searchText: "",
      id: "",
      policyCustomerId: "",
    });

  const fristIndexMeeting = useMemo(() => {
    if (
      meetingData &&
      Array.isArray(meetingData.data) &&
      meetingData.data.length > 0
    ) {
      return meetingData.data[0] as IMeeting;
    }
    return null;
  }, [meetingData]);

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as ICustomer[];
  }, [clientData?.data]);

  const staffList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const policyList = useMemo(() => {
    return (policyData?.data ?? []) as IPolicy[];
  }, [policyData?.data]);

  const meetingCategoryList = useMemo(() => {
    return (getAllMeetingCategoryData?.data ?? []) as IMeetingCategory2[];
  }, [getAllMeetingCategoryData?.data]);

  const policyAllList = useMemo(() => {
    return (policyAllData?.data ?? []) as IPolicy[];
  }, [policyAllData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(staffList)) return [];
    return staffList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [staffList]);

  const policyOptions = useMemo(() => {
    if (!Array.isArray(policyList)) return [];
    return policyList.map((cust) => ({
      label: `${cust.policyNumber}`,
      value: cust.id,
    }));
  }, [policyList]);

  const meetingCategoryOptions = useMemo(() => {
    if (!Array.isArray(meetingCategoryList)) return [];
    return meetingCategoryList.map((cust) => ({
      label: `${cust.name}`,
      value: cust.id,
    }));
  }, [meetingCategoryList]);

  const clientMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    staffList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [staffList]);

  const allPolicyMap = useMemo(() => {
    const map = new Map();
    policyAllList?.forEach((category) => {
      map.set(category.id, category.policyNumber);
    });
    return map;
  }, [policyAllList]);

  useEffect(() => {
    if (fristIndexMeeting) {
      setSelectedMeetingData(fristIndexMeeting);
    }
  }, [fristIndexMeeting, meetingLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedMeetingData?.id,
      staffId: selectedMeetingData?.staffId || "",
      clientId: selectedMeetingData?.clientId || "",
      subject: selectedMeetingData?.subject || "",
      note: selectedMeetingData?.note || "",
      meeting_time: selectedMeetingData?.meeting_time,
      meeting_Date: dayjs(selectedMeetingData?.meeting_Date.toString()),
      policyId: selectedMeetingData?.policyId,
      categoryId: selectedMeetingData?.categoryId,
      emailReminder: selectedMeetingData?.emailReminder || false,
      smsReminder: selectedMeetingData?.smsReminder || false,
      reminderBeforHours: selectedMeetingData?.reminderBeforHours || "",
      createNotification: selectedMeetingData?.createNotification || false,
      adminReminder: selectedMeetingData?.adminReminder || false,
    },
    onSubmit: async (values) => {
      try {
        const temData = {
          id: values?.id,
          clientId: values.clientId,
          staffId: values.staffId,
          subject: capitalizeFirstLetter(values.subject),
          meeting_time: values.meeting_time,
          meeting_Date: values.meeting_Date.format("YYYY-MM-DD"),
          note: values.note,
          policyId: values.policyId,
          categoryId: values.categoryId,
          emailReminder: Boolean(values.emailReminder),
          smsReminder: Boolean(values.smsReminder),
          reminderBeforHours: values.reminderBeforHours,
          createNotification: Boolean(values.createNotification),
          adminReminder: Boolean(values.adminReminder),
        };
        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleEditClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.staffId === "" ||
      // formik.values.clientId === "" ||
      formik.values.subject === "" ||
      !formik.values.meeting_Date ||
      formik.values.categoryId === "" ||
      !dayjs(formik.values.meeting_Date).isValid()
      ? false
      : true;
  }, [formik.values]);

  // useEffect(() => {
  //   if (
  //     formik.values.clientId !== prevClientIdRef.current
  //   ) {
  //     setSelectedCustomerId(formik.values.clientId);
  //     // formik.setFieldValue("policyId", "");
  //   }
  //   prevClientIdRef.current = formik.values.clientId;
  // }, [formik.values.clientId]);

  useEffect(() => {
    if (formik.values.clientId) {
      setSelectedCustomerId(formik.values.clientId);
      // formik.setFieldValue("policyId", "");
    }
  }, [formik.values.clientId]);

  useEffect(() => {
    const exists = policyOptions.some(
      (opt) => opt.value === Number(formik.values.policyId)
    );

    if (!exists && formik.values.policyId) {
      formik.setFieldValue("policyId", "");
    }
  }, [policyOptions, formik.values.policyId]);

  if (isLoading || holidaysIsLoading || holidaysTitleIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IMeeting[] = Array.isArray(data?.data)
    ? (data?.data as IMeeting[])
    : [];

  const handleAddProductClick = () => {
    navigate(
      `/client/meeting/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };

  const handleSettingClick = () => {
    navigate(`/client/meeting/setting`);
  };

  const handleEditClose = () => {
    setOpenDrawer(false);
    setSelectedId("");
    setSelectedMeetingData(null);
  };

  const viewMeetingProfile = () => {
    navigate(`/meeting/profile/${selectedMeetingData?.id}`);
  };

  if (
    isLoading ||
    holidaysIsLoading ||
    cilentIsLoading ||
    staffIsLoading ||
    meetingAllIsLoading ||
    meetingCategoryIsLoading ||
    policyAllIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card
            elevation={2}
            sx={{
              borderRadius: setCardBRadius,
              p: 2,
              mb: 3,
              backgroundColor: theme.palette.cardAdd.bgColor,
              minHeight: "100vh",
            }}
          >
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ padding: 2, borderBottom: 4 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Link
                      to={`/client/meeting/create?date=${paymentMonthYear.format(
                        "YYYY-MM-DD"
                      )}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<BiSolidMessageSquareAdd />}
                        className={classes.addNewButton}
                        onClick={handleAddProductClick}
                      >
                        Add New
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/client/meeting/setting`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<SettingsIcon />}
                        className={classes.addNewButton}
                        onClick={handleSettingClick}
                      >
                        Setting
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item lg={12} md={12} sm={12} xs={12} m={2} pt={4}>
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  events={coursings.map((meeting) => ({
                    id: String(meeting.id),
                    title: meeting.subject,
                    start: meeting.meeting_time
                      ? `${dayjs(meeting.meeting_Date).format("YYYY-MM-DD")}T${
                          meeting.meeting_time
                        }`
                      : dayjs(meeting.meeting_Date).format("YYYY-MM-DD"),
                    backgroundColor: meeting.meeting_category_color,
                    borderColor: meeting.meeting_category_color,
                    textColor: "#fff",
                    display: "block",
                    extendedProps: {
                      meeting_Date: meeting.meeting_Date,
                      meeting_time: meeting.meeting_time,
                      staffId: meeting.staffId,
                      clientId: meeting.clientId,
                      policyId: meeting.policyId,
                      subject: meeting.subject,
                    },
                  }))}
                  eventContent={(eventInfo) => {
                    const {
                      meeting_Date,
                      meeting_time,
                      staffId,
                      clientId,
                      policyId,
                      subject,
                    } = eventInfo.event.extendedProps;

                    const displayTitle =
                      eventInfo.event.title.length > 20
                        ? eventInfo.event.title.slice(0, 20) + "..."
                        : eventInfo.event.title;

                    return (
                      <Tooltip
                        placement="top"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#f9f9f9",
                              color: "#333",
                              border: "1px solid #ccc",
                              borderRadius: 2,
                              boxShadow: 3,
                              padding: 1.5,
                              maxWidth: 500,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#f9f9f9",
                            },
                          },
                        }}
                        title={
                          <Grid container spacing={1}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography
                                fontWeight="bold"
                                fontSize={14}
                                color="#0d47a1"
                              >
                                {subject || displayTitle}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} ml={3}>
                              {meeting_Date && (
                                <Typography fontSize={13}>
                                  <strong>Meeting Date:</strong>{" "}
                                  {dayjs(meeting_Date).format("MMM DD, YYYY")}
                                </Typography>
                              )}
                              {meeting_time && (
                                <Typography fontSize={13}>
                                  <strong>Meeting Time:</strong>{" "}
                                  {formatTime(meeting_time)}
                                </Typography>
                              )}
                              {staffId && (
                                <Typography fontSize={13}>
                                  <strong>Staff:</strong>{" "}
                                  {staffMap.get(Number(staffId)) || "—"}
                                </Typography>
                              )}
                              {clientId && (
                                <Typography fontSize={13}>
                                  <strong>Client:</strong>{" "}
                                  {clientMap.get(Number(clientId)) || "—"}
                                </Typography>
                              )}
                              {policyId && (
                                <Typography fontSize={13}>
                                  <strong>Policy:</strong>{" "}
                                  {allPolicyMap.get(Number(policyId)) || "—"}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        }
                      >
                        <div
                          style={{
                            marginBottom: "6px",
                            borderRadius: "4px",
                            padding: "4px 8px",
                            backgroundColor: eventInfo.backgroundColor,
                            color: eventInfo.textColor,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                            // gap: 3
                          }}
                        >
                          {meeting_time
                            ? `${formatTime(meeting_time)} - ${displayTitle}`
                            : displayTitle}
                        </div>
                      </Tooltip>
                    );
                  }}
                  dateClick={(info: DateClickArg) => {
                    const clickedDate = dayjs(info.dateStr).format(
                      "YYYY-MM-DD"
                    );

                    const holiday = holydaysTitleData?.data?.find(
                      (h) => dayjs(h.date).format("YYYY-MM-DD") === clickedDate
                    );

                    if (holiday) {
                      setAlertMessage(
                        `This date is a holiday: ${
                          holiday.note?.trim() || "Holiday"
                        }`
                      );
                      setDeleteAlert(true);
                      return;
                    }

                    navigate(`/client/meeting/create?date=${info.dateStr}`);
                  }}
                  eventClick={(info) => {
                    const eventId = info.event.id;
                    setOpenDrawer(true);
                    setSelectedId(eventId);
                  }}
                  dayCellDidMount={(arg) => {
                    arg.el.style.cursor = "pointer";

                    const cellDate = dayjs(arg.date).format("YYYY-MM-DD");

                    const holiday = holydaysTitleData?.data?.find(
                      (h) => dayjs(h.date).format("YYYY-MM-DD") === cellDate
                    );

                    if (holiday) {
                      arg.el.style.backgroundColor = "#ffeaea";
                      arg.el.style.position = "relative";

                      const label = document.createElement("div");
                      label.textContent = holiday.note?.trim()
                        ? holiday.note
                        : "Holiday";
                      label.style.position = "absolute";
                      label.style.top = "50%";
                      label.style.left = "50%";
                      label.style.transform = "translate(-50%, -50%)";
                      label.style.fontSize = "12px";
                      label.style.fontWeight = "bold";
                      label.style.color = "#b71c1c";
                      // label.style.backgroundColor = "#fff0f0";
                      label.style.padding = "2px 6px";
                      label.style.borderRadius = "4px";
                      label.style.pointerEvents = "none";

                      arg.el.appendChild(label);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={handleEditClose}
          PaperProps={{
            sx: {
              width: isMobile ? "100vw" : 600,
              maxWidth: "100vw",
              backgroundColor: theme.palette.background.default,
              padding: isMobile ? 1 : 2,
            },
          }}
        >
          {meetingLoading ? (
            <Grid spacing={2} container>
              {/* Card 1 */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  {/* Centered Spinner */}
                  <Grid container spacing={4} p={3}>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="100vh"
                      >
                        <CircularProgress />
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          ) : (
            <Grid spacing={2} container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ padding: 1 }}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        // startIcon={<VisibilityIcon />}
                        onClick={viewMeetingProfile}
                        className={classes.addButton}
                      >
                        <Link
                          to={`/meeting/profile/${selectedMeetingData?.id}`}
                          className={classes.iconLinkPropNormal}
                        >
                          View
                        </Link>
                      </Button>
                      <Box m={0.5}></Box>
                      <Button
                        variant="contained"
                        className={classes.editButton}
                        onClick={handleEditClose}
                      >
                        <CloseIcon />
                      </Button>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        // cursor: "pointer",
                      }}
                      // onClick={viewMeetingProfile}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          width: 56,
                          height: 56,
                          fontSize: 24,
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={viewMeetingProfile}
                      >
                        {selectedMeetingData?.subject ? (
                          selectedMeetingData.subject.charAt(0).toUpperCase()
                        ) : (
                          <GroupIcon />
                        )}
                      </Avatar>
                      <Link
                        to={`/meeting/profile/${selectedMeetingData?.id}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Typography
                          className={classes.mL1Heading}
                          fontWeight={700}
                          sx={{
                            cursor: "pointer",
                            mt: 0.5,
                          }}
                          onClick={viewMeetingProfile}
                        >
                          {selectedMeetingData?.subject || ""}{" "}
                          <FontAwesomeIcon
                            icon={faLink}
                            style={{
                              color: "#757575",
                              marginLeft: 4,
                            }}
                          />
                        </Typography>
                      </Link>
                    </Grid>
                  </Grid>
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={4} p={"24px"}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Subject </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              freeSolo
                              options={
                                meetingAllData?.data?.filter(Boolean) ?? []
                              }
                              loading={meetingAllIsLoading}
                              inputValue={formik.values.subject}
                              onInputChange={(_, value) =>
                                formik.setFieldValue("subject", value)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Subject"
                                  size="small"
                                  multiline
                                  rows={6}
                                  className={classes.textField}
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: { fontSize: 14 },
                                  }}
                                  InputLabelProps={{
                                    sx: { fontSize: 14 },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Category </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={meetingCategoryOptions}
                              loading={meetingCategoryIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                meetingCategoryOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    Number(formik.values.categoryId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "categoryId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Meeting Category .."
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {meetingCategoryIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Staff </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={staffOptions}
                              loading={staffIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                staffOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.staffId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "staffId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => {
                                const selected = staffOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.staffId)
                                );

                                return (
                                  <TextField
                                    {...params}
                                    placeholder="Select staff..."
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    variant="standard"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {staffIsLoading ? (
                                            <CircularProgress size={20} />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </>
                                      ),
                                    }}
                                  />
                                );
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Client </strong>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={customerOptions}
                              loading={cilentIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                customerOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.clientId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "clientId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Client .."
                                  size="small"
                                  variant="standard"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {cilentIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Policy </strong>
                              {/* <span className={classes.requiedfield}>*</span> */}
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={policyOptions}
                              loading={policyIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                policyOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.policyId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "policyId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Policy number .."
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {policyIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Schedule Date</strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={formik.values.meeting_Date}
                                onChange={(meeting_Date) =>
                                  formik.setFieldValue(
                                    "meeting_Date",
                                    meeting_Date
                                  )
                                }
                                // shouldDisableDate={(day) =>
                                //   !!holydaysData?.data?.some((holiday) =>
                                //     day.isSame(dayjs(holiday), "day")
                                //   )
                                // }
                                shouldDisableDate={(day) =>
                                  !!holydaysData?.data?.some((holiday: Dayjs) =>
                                    day.isSame(holiday, "day")
                                  )
                                }
                                slotProps={{
                                  textField: {
                                    placeholder: "Schedule Date",
                                    size: "small",
                                    variant: "standard",
                                    sx: {
                                      width: "100%",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Schedule Time</strong>
                              {/* <span className={classes.requiedfield}>*</span> */}
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TimeDropdown
                              value={formik.values.meeting_time}
                              onChange={(time) =>
                                formik.setFieldValue("meeting_time", time)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          startIcon={
                            meetingSaveIsLoading ? (
                              <CircularProgress
                                size={18}
                                className={classes.isLoading}
                              />
                            ) : (
                              <FaEdit />
                            )
                          }
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || meetingSaveIsLoading}
                        >
                          Update
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Card>
              </Grid>
            </Grid>
          )}
        </Drawer>

        <AlertPopUp
          open={deleteAlert}
          onCloseAlert={setDeleteAlert}
          message={alertMessage}
        />
      </Grid>
    </div>
  );
};

export default Index;
